module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modalBg d-flex flex-column align-items-center justify-content-center",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.handleBackgroundClick.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modalContent p-3"
  }, [_c('h3', {
    staticClass: "text-center bold mb-0"
  }, [_vm._v("Create invoice")]), _vm._v(" "), _c('span', {
    staticClass: "d-flex justify-content-center subtitle"
  }, [_vm._v(_vm._s(_vm.selectedDocumentType ? _vm.selectedDocumentType.label :
    ''))]), _vm._v(" "), (_vm.getIsDownloadingInvoiceResume) ? _c('div', {
    staticClass: "d-flex w-100 justify-content-center my-4"
  }, [_c('loader')], 1) : _c('div', {
    staticClass: "mt-3 invoice-to-toggle"
  }, [_c('button', {
    staticClass: "invoice-to-toggle__btn",
    class: {
      active: _vm.invoiceTo == 'customer'
    },
    on: {
      "click": function($event) {
        return _vm.setInvoiceTo('customer')
      }
    }
  }, [_vm._v("Customer")]), _vm._v(" "), _c('button', {
    staticClass: "invoice-to-toggle__btn",
    class: {
      active: _vm.invoiceTo == 'agent'
    },
    attrs: {
      "disabled": !_vm.enableAgentBtn
    },
    on: {
      "click": function($event) {
        return _vm.setInvoiceTo('agent')
      }
    }
  }, [_vm._v("Agent")])]), _vm._v(" "), (_vm.invoiceTo) ? _c('div', {
    staticClass: "amount-card mt-3 mb-4"
  }, [_c('div', {
    staticClass: "amount-card__item"
  }, [_c('div', {
    staticClass: "amount-card__label"
  }, [_vm._v("\n                    Amount to invoice"), (_vm.isDocTypeInvoice) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "amount-card__value amount-card__value--amount"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.valueToInvoice)) + " €")])]), _vm._v(" "), _c('div', {
    staticClass: "amount-card__item"
  }, [_c('div', {
    staticClass: "amount-card__label"
  }, [_vm._v("Due")]), _vm._v(" "), _c('div', {
    staticClass: "amount-card__value",
    class: {
      'color-3': _vm.invalidInvoiceValue
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.valueToInvoice)) + " €")])]), _vm._v(" "), _c('div', {
    staticClass: "amount-card__item"
  }, [_c('div', {
    staticClass: "amount-card__label"
  }, [_vm._v("Total")]), _vm._v(" "), _c('div', {
    staticClass: "amount-card__value"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.transactionTotal)) + " €")])])]) : _vm._e(), _vm._v(" "), (_vm.invoiceTo && !_vm.getIsPrimaveraSettingsLoading) ? _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Document type")]), _vm._v(" "), (!_vm.getIsDocumentTypesLoading) ? _c('v-select', {
    attrs: {
      "options": _vm.documentTypesOptions,
      "label": "label",
      "value": _vm.selectedDocumentType,
      "clearable": false,
      "disabled": _vm.isSubmittingInvoice
    },
    on: {
      "input": _vm.onDocumentTypeChange
    }
  }) : _c('loader')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    class: {
      error: _vm.$v.invoiceToForm.businessName.$invalid
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_vm._m(0), _vm._v(" "), (_vm.$v.invoiceToForm.businessName.$invalid) ? _c('div', {
    staticClass: "messages fs-smaller"
  }, [(!_vm.$v.invoiceToForm.businessName.required) ? _c('span', [_vm._v("Required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceToForm.businessName),
      expression: "invoiceToForm.businessName"
    }],
    staticClass: "full",
    attrs: {
      "type": "text",
      "disabled": _vm.isSubmittingInvoice
    },
    domProps: {
      "value": (_vm.invoiceToForm.businessName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceToForm, "businessName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-3",
    class: {
      error: _vm.$v.invoiceToForm.vat.$invalid
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('label', [_vm._v("\n                        VAT number "), (_vm.isDocTypeInvoice) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.$v.invoiceToForm.vat.$invalid) ? _c('div', {
    staticClass: "messages fs-smaller"
  }, [(!_vm.$v.invoiceToForm.vat.required) ? _c('span', [_vm._v("Required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceToForm.vat),
      expression: "invoiceToForm.vat"
    }],
    staticClass: "full",
    attrs: {
      "type": "text",
      "disabled": _vm.isSubmittingInvoice
    },
    domProps: {
      "value": (_vm.invoiceToForm.vat)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceToForm, "vat", $event.target.value)
      }, _vm.$v.invoiceToForm.vat.$touch]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-3",
    class: {
      error: _vm.$v.invoiceToForm.address.$invalid
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('label', [_vm._v("\n                        Address "), (_vm.isDocTypeInvoice) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.$v.invoiceToForm.address.$invalid) ? _c('div', {
    staticClass: "messages fs-smaller"
  }, [(!_vm.$v.invoiceToForm.address.required) ? _c('span', [_vm._v("Required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceToForm.address),
      expression: "invoiceToForm.address"
    }],
    staticClass: "full",
    attrs: {
      "type": "text",
      "disabled": _vm.isSubmittingInvoice
    },
    domProps: {
      "value": (_vm.invoiceToForm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceToForm, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 mt-3",
    class: {
      error: _vm.$v.invoiceToForm.city.$invalid
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('label', [_vm._v("\n                        City "), (_vm.isDocTypeInvoice) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.$v.invoiceToForm.city.$invalid) ? _c('div', {
    staticClass: "messages fs-smaller"
  }, [(!_vm.$v.invoiceToForm.city.required) ? _c('span', [_vm._v("Required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceToForm.city),
      expression: "invoiceToForm.city"
    }],
    staticClass: "full",
    attrs: {
      "type": "text",
      "disabled": _vm.isSubmittingInvoice
    },
    domProps: {
      "value": (_vm.invoiceToForm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceToForm, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 mt-3",
    class: {
      error: _vm.$v.invoiceToForm.postalCode.$invalid
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('label', [_vm._v("\n                        Postal Code "), (_vm.isDocTypeInvoice) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.$v.invoiceToForm.postalCode.$invalid) ? _c('div', {
    staticClass: "messages fs-smaller"
  }, [(!_vm.$v.invoiceToForm.postalCode.required) ? _c('span', [_vm._v("Required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceToForm.postalCode),
      expression: "invoiceToForm.postalCode"
    }],
    staticClass: "full",
    attrs: {
      "type": "text",
      "disabled": _vm.isSubmittingInvoice
    },
    domProps: {
      "value": (_vm.invoiceToForm.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceToForm, "postalCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 mt-3",
    class: {
      errorSelect: _vm.$v.invoiceToForm.country.$invalid
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('label', [_vm._v("\n                        Country "), (_vm.isDocTypeInvoice) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.$v.invoiceToForm.country.$invalid) ? _c('div', {
    staticClass: "messages fs-smaller error"
  }, [(!_vm.$v.invoiceToForm.country.required) ? _c('span', [_vm._v("Required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('country-picker', {
    attrs: {
      "openDirection": 'top',
      "selectedCountryValue": _vm.selectedCountry,
      "disabled": false,
      "allowEmpty": false
    },
    on: {
      "input": function($event) {
        return _vm.updateCountry($event)
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.getIsPrimaveraSettingsLoading) ? _c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('loader', {
    attrs: {
      "size": "big"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.invoiceTo) ? _c('div', {
    staticClass: "mt-5 text-right d-flex w-100 justify-content-end align-items-center"
  }, [_c('button', {
    staticClass: "btn tertiary",
    attrs: {
      "disabled": _vm.isSubmittingInvoice
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('loading-button', {
    staticClass: "btn ml-2",
    attrs: {
      "disabled": _vm.invalidInvoiceValue || _vm.isCreatingAndPrinting || _vm.getIsPrimaveraSettingsLoading || _vm.$v.$invalid,
      "loading": _vm.isCreating
    },
    on: {
      "click": function($event) {
        return _vm.createInvoice(false)
      }
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('loading-button', {
    staticClass: "btn ml-2",
    attrs: {
      "disabled": _vm.invalidInvoiceValue || _vm.isCreating || _vm.getIsPrimaveraSettingsLoading || _vm.$v.$invalid,
      "loading": _vm.isCreatingAndPrinting
    },
    on: {
      "click": function($event) {
        return _vm.createInvoice(true)
      }
    }
  }, [_vm._v("Create and Print")])], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                        Invoice name "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-9dd5dc10", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9dd5dc10"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/Invoice/CreateInvoice.vue
// module id = 1777
// module chunks = 0